import { useNumberWithCommas } from '@/store/hooks'
import selectOption from '@/store/dict/selectOptionDict'

export default function config() {
  const receiptColumns = [
    {
      name: 'id',
      columnProps: {
        label: '应收ID',
        prop: 'id',
      },
    },
    {
      name: 'content',
      columnProps: {
        label: '收款内容',
        prop: 'content',
      },
    },
    {
      name: 'receivableAmount',
      columnProps: {
        label: '应收金额(元)',
        prop: 'receivableAmount',
      },
      getText: ({ row }) => useNumberWithCommas(row.receivableAmount),
    },
    {
      name: 'receivedAmount',
      columnProps: {
        label: '已收金额(元)',
        prop: 'receivedAmount',
      },
      getText: ({ row }) => useNumberWithCommas(row.receivedAmount),
    },
    {
      name: 'receivingAmount',
      columnProps: {
        label: '收款中金额(元)',
        prop: 'receivingAmount',
      },
      getText: ({ row }) => useNumberWithCommas(row.receivingAmount),
    },
    {
      name: 'remainAmount',
      columnProps: {
        label: '剩余应收金额(元)',
        prop: 'remainAmount',
      },
      getText: ({ row }) => useNumberWithCommas(row.remainAmount),
    },
    {
      name: 'receivableState',
      columnProps: {
        label: '收款状态',
        prop: 'receivableState',
      },
      render: ({ row }) => {
        const text = selectOption.completionStatusDict[row.receivableState]
        const typeMap = {
          0: 'warning',
          1: 'success',
          2: 'info',
        }
        const tagType = typeMap[row.receivableState]
        return (
          <el-tag size="small" type={tagType}>{text || '--'}</el-tag>
        )
      },
    },
    {
      name: 'completeTime',
      columnProps: {
        label: '收款完成时间',
        prop: 'completeTime',
      },
    },
  ]
  return {
    receiptColumns,
  }
}
